import axiosInstance from "../utils/axiosInstance";
import { telemetryClient } from "../../services/telemetryClient";

const ENDPOINT = "/audio-transcription/create";

interface CreateAudioTranscriptionResponse {
  message: string;
  jobId: string;
}

export type AudioLanguage = "af" | "en";

export const DEFAULT_AUDIO_LANGUAGE: AudioLanguage = "af";

interface CreateAudioTranscriptionOptions {
  dictationMode?: boolean;
  aiCorrection?: boolean;
  speakerIdentification?: boolean;
  numSpeakers?: number;
  speakerNames?: Record<string, string>;
  vocabulary?: string;
  filePasswords?: Record<string, string>;
  enableDocumentChat?: boolean;
  language?: AudioLanguage;
}

export const createAudioTranscription = async (
  files: string[],
  options: CreateAudioTranscriptionOptions = {},
): Promise<CreateAudioTranscriptionResponse> => {
  const startedAt = Date.now();
  telemetryClient.log("job.createRequest.start", { metadata: { endpoint: ENDPOINT } });
  try {
    const response = await axiosInstance.post<CreateAudioTranscriptionResponse>(
      ENDPOINT,
      {
        files,
        dictationMode: !!options.dictationMode,
        aiCorrection: !!options.aiCorrection,
        speakerIdentification: !!options.speakerIdentification,
        ...(options.numSpeakers ? { numSpeakers: options.numSpeakers } : {}),
        ...(options.speakerNames && Object.keys(options.speakerNames).length > 0
          ? { speakerNames: options.speakerNames }
          : {}),
        ...(options.vocabulary?.trim() ? { vocabulary: options.vocabulary.trim() } : {}),
        ...(options.filePasswords && Object.keys(options.filePasswords).length > 0
          ? { filePasswords: options.filePasswords }
          : {}),
        enableDocumentChat: !!options.enableDocumentChat,
        ...(options.language ? { language: options.language } : {}),
      },
    );

    telemetryClient.log("job.createRequest.success", {
      jobId: response.data.jobId,
      metadata: { endpoint: ENDPOINT, durationMs: Date.now() - startedAt },
    });
    return response.data;
  } catch (error: any) {
    telemetryClient.log("job.createRequest.error", {
      level: "error",
      metadata: {
        endpoint: ENDPOINT,
        durationMs: Date.now() - startedAt,
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
      },
    });
    throw new Error(error.response?.data?.message || "Failed to create audio transcription.");
  }
};
